import type { ReactElement } from 'react'

import { useTrackExpertReportEntry } from '../../hooks/useTrackExpertReportEntry'

export const ExpertReportTracking = (): ReactElement | null => {
  useTrackExpertReportEntry()

  return null
}
